import { Box, Heading, SimpleGrid } from '@chakra-ui/react';
import BPCPageHeading from 'common/components/BPCPageHeading';
import Loader from 'common/components/Loader';
import { useGetChampionnatList } from 'features/championnats/championnat.api';
import { useConnectedUserContext } from 'features/user/useConnectedUserContext';
import ChampionnatJoueurActifCard from 'features/championnats/components/ChampionnatJoueurActifCard';
import { useGetChampionnatsPersonnalises } from 'features/championnats/championnat.api';
import ChampionnatPersonnaliseActifCard from 'features/championnats/components/ChampionnatPersonnaliseActifCard';
import TournoiList from 'features/tournois/components/TournoiList';

//TODO: gamification
export default function HomePage() {
  const { championnats, tournois, isLoading: isLoadingChampionnats } =
    useGetChampionnatList();
  const { user } = useConnectedUserContext();
  const {
    championnats: championnatsPersonnalises,
    isLoading: isLoadingPersonnalises,
  } = useGetChampionnatsPersonnalises(user?.id);

  if (isLoadingChampionnats || isLoadingPersonnalises)
    return <Loader my={5} />;

  return (
    <Box>
      <BPCPageHeading helmetName="Home" />
      {tournois.some(({ status }) => status !== 'finished') && (
        <Box mb="8">
          <Heading mb="4" size="md">
            Tournois en cours ou à venir
          </Heading>
          <TournoiList
            tournois={tournois.filter(({ status }) => status !== 'finished')}
            openLiveOnClick
            columns={{ base: 1, md: 3, lg: 4 }}
          />
        </Box>
      )}
      {user && championnats.some(({ isActive }) => isActive) && (
        <Box mb="8">
          <Heading mb="4" size="md">
            Mes championnats en cours
          </Heading>
          <SimpleGrid columns={1} spacing="5">
            {championnats
              .filter(({ isActive }) => isActive)
              .map((championnat) => (
                <ChampionnatJoueurActifCard
                  key={championnat.id}
                  championnat={championnat}
                  user={user}
                />
              ))}
          </SimpleGrid>
        </Box>
      )}
      {championnatsPersonnalises.some(({ isActive }) => isActive) && (
        <Box mb="8">
          <Heading mb="4" size="md">
            Mes championnats personnalisés en cours
          </Heading>
          <SimpleGrid columns={1} spacing="5">
            {championnatsPersonnalises
              .filter(({ isActive }) => isActive)
              .map((championnat) => (
                <ChampionnatPersonnaliseActifCard
                  key={championnat.id}
                  championnat={championnat}
                />
              ))}
          </SimpleGrid>
        </Box>
      )}
    </Box>
  );
}
